import React, {FC} from 'react';

import {PartialLocation} from '..';

import * as styles from './styles.module.scss';

type CrumbsProps = {
	location: PartialLocation
};

const Crumbs: FC<CrumbsProps> = ({location}) => {
	const parts = [
		{
			text: 'Home',
			href: '/',
		},
		{
			text: 'Locations',
			href: '/booking',
		},
		{
			text: location.details.name,
		},
	];

	return (
		<ul className={styles.crumbs}>
			{parts.map((part, index) => (
				<li key={index}>
					<a href={part.href}>{part.text}</a>
				</li>
			))}
		</ul>
	);
};

export default Crumbs;
